import React from 'react';
import PropTypes from 'prop-types';
import CurrencyIcon from '../CurrencyIcon';
import { GenericLoading } from '../Placeholders';

const FeatureItem = ({
  onClick,
  label,
  image,
  subtitle,
  className,
  dataTestid,
  icon,
  iconElement,
  disabled,
  coin,
  link,
  linkDownloadTitle,
  linkDownloadUrl,
  loading,
}) => {
  const renderContent = () => (
    <>
      <div className="form-check d-flex p-0 align-items-center">
        {coin && <CurrencyIcon currencyCode={coin} className="me-2" />}
        {image && (
          <img
            style={{ minWidth: '1.563rem', resizeMode: 'contain', opacity: disabled ? 0.5 : 1 }}
            src={image}
            alt={label}
            className="me-2"
          />
        )}
        {icon && (
          <i
            className={`d-flex me-2 ${
              disabled ? 'text-disabled' : 'text-primary'
            }  text-f4 ${icon}`}
          />
        )}
        {iconElement && (
          <div className="me-2" style={{ width: '1.5rem', height: '1.5rem' }}>
            {iconElement}
          </div>
        )}
        <div className="d-flex flex-column mx-2">
          <b className={`text-f5  ${disabled ? 'text-disabled' : 'text-dark'}`}>{label}</b>
          {subtitle && (
            <p
              className={`text-f6 ${
                disabled ? 'text-disabled' : 'text-shadow'
              }`}>{`${subtitle}`}</p>
          )}
        </div>
        <i
          className={`d-flex ms-auto icon-arrow-next-navigation m-0 ${
            disabled ? 'text-disabled' : 'text-primary'
          }`}
        />
      </div>
    </>
  );

  if (link) {
    return (
      <div
        data-testid={dataTestid}
        className={`bg-light ${
          disabled ? '' : 'feature-item'
        } px-3 py-3 rounded-extra my-2 ${className}`}>
        <a
          target="_blank"
          className="text-decoration-none"
          href={linkDownloadUrl || '#'}
          download={linkDownloadTitle}
          rel="noreferrer">
          {renderContent()}
        </a>
      </div>
    );
  }

  return (
    <div
      data-testid={dataTestid}
      role="button"
      tabIndex="0"
      onClick={!disabled ? onClick : () => {}}
      onKeyPress={!disabled ? onClick : () => {}}
      className={`bg-light ${
        disabled ? '' : 'feature-item'
      } px-3 py-3 rounded-extra my-2 ${className}`}>
      {!loading ? (
        renderContent()
      ) : (
        <GenericLoading isFullScreen={false} customSize="3rem" customSpacing="my-0" />
      )}
    </div>
  );
};

export default FeatureItem;

FeatureItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  image: PropTypes.string,
  icon: PropTypes.string,
  iconElement: PropTypes.element,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  dataTestid: PropTypes.string,
  disabled: PropTypes.bool,
  link: PropTypes.bool,
  loading: PropTypes.bool,
  coin: PropTypes.string,
  linkDownloadTitle: PropTypes.string,
  linkDownloadUrl: PropTypes.string,
};

FeatureItem.defaultProps = {
  image: null,
  subtitle: null,
  className: '',
  dataTestid: '',
  icon: null,
  iconElement: null,
  disabled: false,
  loading: false,
  coin: null,
  link: false,
  linkDownloadTitle: '',
  linkDownloadUrl: '#',
};
